<template>
    
    <div>

		<div class="content-header">
			<div class="content-header-inner">
				<h1 class="content-header-title" v-html="!hasFullAccess?'The users area only available on your account or a shared account that you have full access to.':'Users'" />
				<span 
					class="large-button sits-right"
					@click="showInvite=true"
					v-if="!isShared"
				>Invite</span>
			</div>
		</div>

    	<section class="outer-pad" v-if="hasFullAccess">

			<Table 
				:headings="headings" 
				:items="table.items" 
				:loading="table.loading"
				@selectUser="selectUser"
				@deleteUser="deleteUser"
				emptyLabel="No users at the moment"
				loadingText="Fetching users..."
				name="users"
			/>

		</section>

		<div class="content-header" v-if="hasFullAccess">
			<div class="content-header-inner">
				<h2 class="content-header-title">Invites (people without an account)</h2>
			</div>
		</div>

    	<section class="outer-pad" v-if="hasFullAccess">

			<Table 
				:headings="headings2" 
				:items="table2.items" 
				:loading="table2.loading"
				@selectUser="selectUser"
				@deleteUser="deleteUser"
				emptyLabel="No outstanding invites"
				loadingText="Fetching invites..."
				name="invites"
			/>

		</section>

		<Invite 
			v-if="showInvite" 
			:currentProjects="projects"
			:id="id"
			:type="type"
			:userName="userName"
			:firstName="firstName"
			:lastName="lastName"
			:userEmail="userEmail"
			:readOnly="readOnly"
			:fullAccess="fullAccess"
			@close-invite="closeInvite" 
		/>

    </div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import Table from './../components/Table.vue'
import Invite from './../components/Invite.vue'
import TableButton from './../components/Display/TableButton.vue'
export default {
  	name: 'Users',
  	props: {},
  	components: { Table, Invite },
  	data() {

		return {
			fetched: false,
			showInvite: false, 
			projects: [],
			id: '',
			userName: '',
			firstName: '',
			lastName: '',
			userEmail: '',
			type: '',
			readOnly: false,
			fullAccess: false,
			table: {
				page: 1,
				sorted: {},
				items: [],
				search: {},
				loading: true
			},
			table2: {
				page: 1,
				sorted: {},
				items: [],
				search: {},
				loading: true
			}
		}

	},
	computed: {
		...mapState('general',['userInfo']),
		isShared() {

			return !!this.userInfo.isShared;

		},
		hasFullAccess() {
			
			return this.userInfo.access === 'full-access';

		},
		headings() {

			let clickVars = ['_id','type','projectIds','name','email','firstName','lastName','level','fullAccess','readOnly'];

			return {
				name: { value: 'Name', click: 'selectUser', 'clickVars': clickVars },
				email: { value: 'Email', click: 'selectUser', 'clickVars': clickVars },
				global: { value: 'Global Access', click: 'selectUser', 'clickVars': clickVars, emptyCell: 'Not set' },
				projects: { value: 'Projects', click: 'selectUser', 'clickVars': clickVars, emptyCell: 'No individual projects' },
				delete: { value: 'Delete', component: TableButton, event: 'deleteUser' }
			}

		},
		headings2() {

			let clickVars = ['_id','type','projectIds','name','email','firstName','lastName','level','fullAccess','readOnly'];

			return {
				name: { value: 'Name', click: 'selectUser', 'clickVars': clickVars },
				email: { value: 'Email', click: 'selectUser', 'clickVars': clickVars },
				global: { value: 'Global Access', click: 'selectUser', 'clickVars': clickVars, emptyCell: 'Not set' },
				projects: { value: 'Projects', click: 'selectUser', 'clickVars': clickVars, emptyCell: 'No individual projects' },
				delete: { value: 'Delete', component: TableButton, event: 'deleteUser' }
			}

		}

	},
	methods : {
		...mapMutations('general',['updateLoadingText']),

		selectUser({ _id, type, projectIds, name, email, firstName, lastName, level, fullAccess, readOnly }) {

			this.showInvite = true;
			this.projects = projectIds;
			if ( level ) {
				Object.keys(level).forEach ( function(l) {

					if ( l !== 'normal' ) {

						this.projects.push(level[l]+'-'+l);

					}

				}.bind(this));
			}
			this.id = _id;
			this.userName = name;
			this.firstName = firstName;
			this.lastName = lastName;
			this.userEmail = email;
			this.fullAccess = !!fullAccess;
			this.readOnly = !!readOnly;
			this.projects = projectIds;
			this.type = type;

		},

		deleteUser({ _id, theType, name }) {

			this.$dialog
			.confirm('Delete ' + name + '?', { okText: 'Delete', cancelText: 'Cancel',})
			.then(function() {
				
				let uri = theType === 'invited' ? 'invited' : 'colabs';

				this.updateLoadingText("Deleting...");

				ApiService.delete( 'users/' + uri + '/' + _id )
				.then( function( info ) {

					this.updateLoadingText();

					if ( theType === 'invited' ) 
						this.getInvites (); 
					else 
						this.getUsers ();

				}.bind(this))
				.catch( function(err) {

				}.bind(this));

			}.bind(this))
			.catch(function() {
				
				this.updateLoadingText();

			});

		},

		closeInvite(reload) {

			this.showInvite = false;
			this.projects = [];
			this.id = '';
			this.userName = '';
			this.userEmail = '';
			this.type = '';

			general.modalClose();

			if ( reload ) {

				this.getUsers ();
				this.getInvites ();

			}

		},

		getUsers () {

			this.updateLoadingText(true);

			ApiService.get( 'users/colabs' )
			.then( function( info ) {

				Vue.set( this.table, 'items', info.data );

				this.fetched = true;

				this.table.loading = false;

				this.updateLoadingText();

				this.getInvites ();

			}.bind(this))
			.catch( function(err) {

				this.updateLoadingText();
				this.fetched = true;
				this.table.loading = false;
				this.table2.loading = false;

			}.bind(this));

		},

		getInvites () {

			this.updateLoadingText(true);

			ApiService.get( 'users/invited' )
			.then( function( info ) {

				Vue.set( this.table2, 'items', info.data );

				this.fetched = true;

				this.table2.loading = false;

				this.updateLoadingText();

			}.bind(this))
			.catch( function(err) {

				this.updateLoadingText();

			}.bind(this));

		}
		
	},
	created() { 

		this.getUsers ();

	}
}
</script>